/**
 * /settings/earnings — the seller's ledger.
 *
 * Gated on VITE_PAYMENTS, which is baked at UI build time, and it REDIRECTS rather than
 * mounting an empty shell — the same shape as /settings/usage and /settings/supervision.
 * The tab is not in the nav when the flag is off, so a direct hit on the URL is the only
 * way to arrive, and landing on a blank page reads as a broken page rather than as a
 * feature that is not on.
 *
 * THE FLAG GATES THE SCREEN, NOT THE MONEY. The commission, the hold and the triple lock
 * on live money are the gateway's and are unaffected by this. Turning it off hides the
 * report; it does not stop a payout, and it does not stop a seller being owed.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/earnings')({
  beforeLoad: () => {
    if (!env.VITE_PAYMENTS) {
      throw redirect({ to: '/settings/profile', replace: true });
    }
  },
});
